import { Coordinates } from "../../Components";
import { useEffect, useState } from "react";
import { CountryCode } from "libphonenumber-js";

interface IpLocation {
  coordinates?: Coordinates;
  countryCode?: CountryCode;
  ip?: string;
  loading: null | boolean;
  error: null | string;
}

export const useIpLocation = (): IpLocation => {
  const [coordinates, setCoordinates] = useState<IpLocation["coordinates"]>();
  const [countryCode, setCountryCode] = useState<IpLocation["countryCode"]>();
  const [ip, setIp] = useState<IpLocation["ip"]>();
  const [loading, setLoading] = useState<IpLocation["loading"]>(null);
  const [error, setError] = useState<IpLocation["error"]>(null);

  useEffect(() => {
    const api = process.env.REACT_APP_IPSTACK_PATH;
    const key = process.env.REACT_APP_IPSTACK_APIKEY;

    const getCoordinates = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${api}/check?access_key=${key}&fields=latitude,longitude,country_code,ip`
        );
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`
          );
        }
        const data = await response.json();
        if (data) {
          setCoordinates({
            latitude: data.latitude,
            longitude: data.longitude,
          });
          setCountryCode(data.country_code);
          setIp(data.ip);
        }
      } catch (err) {
        setError((err as { message: string })?.message);
      } finally {
        setLoading(false);
      }
    };

    getCoordinates();
  }, []);

  return { coordinates, countryCode, loading, error, ip };
};
